import {
  TextInputField as _TextInputField,
  TextInputProps as _TextInputProps,
} from './TextInput';

export { default } from './TextInput';

export type TextInputField = _TextInputField;
export type TextInputProps = _TextInputProps;
